import { URL } from '../../config.js';
import {axios} from '../../handlers/RequestHandler';
import store from '../store';
import { tableRemoveAcount , tableUpdate } from './tableActions';
import Notification from '../../handlers/Notification';
import { b64toBlob } from './UtilsOperation';

let clear = {
    display_name:'',
    avatar_url:'',
    email:'',
    name:'',
    phone:'',
    status:'',
    password:"secret",
}

const clearProvider  = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_PROVIDER',
            provider: {
                id: '',
                name: '',
                display_name: '',
                phonePrefix: '58',
                phone: '',
                email: ''
            },
            dropzoneFiles:[]
        })
    }
}

const clearProviderAdvanceConfig = () => {
    return (dispatch) => {
        dispatch({
            type: "INVALID_ADVANCE_CONFIG",
            invalidConfig: {}
        });
    }
}

const clearProviders  = () => {
    return (dispatch) => {
        dispatch({
            type: 'CLEAR_PROVIDERS',
            providers:[],
        })
    }
}

const fetchArchivedProviders = (page=1,query,limit = 10) => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let url_host = `/providers?with=skills,delivery-vehicles,accesses&mode=deleted&limit=${limit}&page=${page}`;
        url_host += query ? ('&' + query) : '';
        return axios.get(URL + store.getState().company.id + url_host)
        .then( (res) => {
            dispatch({
                type: 'FETCH_PROVIDERS',
                providers:  res.data
            })
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.user_delete_failed });
            }
        });
    }
}

const fetchProviders  = (page=1,query,setConditionState=null,limit = 500, loader = true) => {
    return (dispatch, getState) => {
        const { company, json_lang } = getState();
        if(loader) dispatch({type: "WAIT_FOR_RESPONSE"})
        let url_host = `/providers?with=skills,delivery-vehicles,accesses&limit=${limit}&page=${page}`;
        if(query && query.startsWith('order_id=')){
            url_host = `/providers?with=skills,delivery-vehicles,accesses`;
        }

		url_host += query ? ('&' + query) : '';
        return axios.get(`${URL + company.id+url_host}`).then( (res) => {
            if(res.data.data){
                res.data.data = res.data.data.map( (provider) => {
                    provider.position =[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000]
                    return (provider)
                })
                dispatch({
                    type: 'SET_HAS_FLEETS',
                    hasFleets: false
                });
            }else{
                dispatch({
                    type: 'SET_HAS_FLEETS',
                    hasFleets: true
                });
                res.data = res.data.map( (provider) => {
                    provider.position =[parseInt(provider.latitude_e6,10)/1000000,parseInt(provider.longitude_e6,10)/1000000]
                    return (provider)
                })
            }

            if (setConditionState==="autocompleteSearch") {
                dispatch({
                    type: 'FETCH_AUTOCOMPLETE_SEARCH_PROVIDERS',
                    autocompleteProviders: res.data
                })
            }else{
                dispatch({
                    type: 'FETCH_PROVIDERS',
                    providers: res.data
                })
            }
        }).catch((err) => {
            if(loader) dispatch({type: "REMOVE_LOADING"})
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: json_lang.custom_errors.retrieving_user_list });
        });
    }
}



const find = (id) => {
    return (dispatch,getState) => {
        return axios.get(`${URL+getState().company.id}/providers/${id}?with=accesses,skills,delivery-vehicles,fleetMembers.fleet.serviceSupplier,serviceProfiles`).then( (res) => {
            res.data.accesses.forEach((access)=>{
                access.access_type = access.access_type.split('\\')[1].toLowerCase()
            })
            dispatch({
                type: 'FETCH_PROVIDER',
                provider: res.data,
            })
            dispatch({
                type: 'FETCH_PROVIDERS_VEHICLES',
                providersVehicle: res.data.delivery_vehicles
            })
            dispatch({
                type: 'LIST_PROVIDER_SKILLS_GROUP',
                providerSkillsGroups: res.data.skills
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.retrieving_user_data });
            }
        });
    }
}

const toggleData = (value) => {
    return (dispatch,getState) => {
        var data = { ...getState().provider }
        if(value.name.split("-").length >1){
            var mValue = parseInt(value.data,10)
            data.status ^= mValue
            if( (data.status&768) === 0){
                data.status ^= 768 - mValue
            }
        }if(value.name =='is_deliverer'|| value.name =='is_shopper'){
            data[value.name] = value.checked === true ? true : false;
        }else{
            data[value.name] = value.data;
        }

        if(value.data === 'company'){
            data.access_id ? data.access_id = '' : null
        }

		dispatch({
		    type: 'FETCH_PROVIDER',
		    provider: data
		})
    }
}

const register = () => {
    return (dispatch, getState) => {
        var data={...getState().provider}
        var provider = new FormData();
        const providerPhone = `+58${data.phone_prefix}${data.phone}`;
        provider.append('display_name', data.display_name)
        provider.append('email', data.email)
        provider.append('name', data.name)
        provider.append('phone', providerPhone)
        provider.append('password',"secret")
        provider.append('access_type',data.access_type)
        provider.append('access_id',data.access_type === 'company' ? getState().company.id : data.access_id)
        provider.append('is_deliverer', data.is_deliverer && data.is_deliverer === true ? 1 : 0)
        provider.append('is_shopper', data.is_shopper && data.is_shopper === true ? 1 : 0)

        if(getState().dropzoneFiles.length){
            var block = getState().dropzoneFiles.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            provider.append('avatar', blob);
        }
        /*else if(data.avatar_url && data.avatar_url.length ){
           provider.append('avatar_url', data.avatar_url)
        }*/
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL +  getState().company.id}/providers?skip_disable_route=1`, provider).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg: getState().json_lang.custom_success.saved_successful});
            dispatch({type: "REMOVE_LOADING"});
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if ( err.data && err.data.message.indexOf("already_exists") === 0 || err.message === 'The entity already exists' )
                Notification.show({type: "error", title: getState().json_lang.custom_errors.user_registration_failed, msg: getState().json_lang.custom_errors.user_already_exist});
            else if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_registration_failed});
        });
    }
}

const update = (initialProvider) => {
    return (dispatch,getState) => {
		let { provider, company }= getState();

		// debo buscar en la lista de providers, xq hay atributos que el api no devuelve, x ejm
		// el account status, para saber si esta confirmado o no, q se usa en la tabla
		//!const modifiedProvider = providers.find( p => p.id === provider.id);
        let providerData = {};

        if(provider.name !== initialProvider.name){
            providerData.name = provider.name;
        }
        if(provider.is_deliverer !== initialProvider.is_deliverer){
            providerData.is_deliverer = provider.is_deliverer;
        }
        if(provider.is_shopper !== initialProvider.is_shopper){
            providerData.is_shopper = provider.is_shopper;
        }
        if(`+58${provider.phone_prefix}${provider.phone}` !== initialProvider.phone){
            providerData.phone = `+58${provider.phone_prefix}${provider.phone}`;
        }

        if(provider.email !== initialProvider.email){
            providerData.email = provider.email;
        }

        if(Object.keys(providerData).length === 0){
            return Promise.resolve();
        }

		dispatch({type: "WAIT_FOR_RESPONSE"});

        if(provider.email !== initialProvider.email){

            return axios.post(`${URL + company.id}/accounts/${provider.account_id}/update-email`, {"email": provider.email})
    
                .then( email_res => {
                    provider.email = email_res.data.email;
                    provider.status =undefined
                    return axios.patch(URL + company.id + '/providers/' + provider.id, providerData)
                })
                .then( res => {
                    dispatch({type: "REMOVE_LOADING"});
                    var succesful = getState().json_lang.common.success
                    Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.update_successful});
                    // luego como provider tiene la data actualizada a cambiar, sustituyo
                    /* let newProvider = {
                        ...modifiedProvider,
                        ...res.data
                    }
                    res.data = newProvider; */
    
                    // dispatch({
                    //     type: 'UPDATE_PROVIDER_SUCCESS',
                    //     //providers:  tableUpdate(res, "providers"),
                    //     provider: clear ? res.data : clear,
                    //     preloader: false
                    // })
                }).catch((err) => {
                    dispatch({type: "REMOVE_LOADING"});
                    if(err.message && err.message !== 'generic')
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                    else
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_update_failed});
                })
        } else {
            return axios.patch(URL + company.id + '/providers/' + provider.id, providerData)
                .then( res => {
                    dispatch({type: "REMOVE_LOADING"});
                    var succesful = getState().json_lang.common.success
                    Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.update_successful});
                    // luego como provider tiene la data actualizada a cambiar, sustituyo
                    /* let newProvider = {
                        ...modifiedProvider,
                        ...res.data
                    }
                    res.data = newProvider; */
    
                    // dispatch({
                    //     type: 'UPDATE_PROVIDER_SUCCESS',
                    //     //providers:  tableUpdate(res, "providers"),
                    //     provider: clear ? res.data : clear,
                    //     preloader: false
                    // })
                }).catch((err) => {
                    dispatch({type: "REMOVE_LOADING"});
                    if(err.message && err.message !== 'generic')
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
                    else
                        Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_update_failed});
                });
        }
    }
}

const updateAvatar = (clear) => {
    return (dispatch,getState) => {
        var data={...getState().provider}
        var provider = new FormData();
        if(getState().dropzoneFiles.length){
            var block = getState().dropzoneFiles.split(";");
            var contentType = block[0].split(":")[1];
            var realData = block[1].split(",")[1];
            var blob = b64toBlob(realData, contentType);
            provider.append('avatar', blob);
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL}${getState().company.id}/providers/${data.id}/upload-avatar`, provider ).then( (res) => {
            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.update_successful});
            if(clear){
                dispatch({
                    type: 'UPDATE_PROVIDER_SUCCESS',
                    providers:  tableUpdate(res, "providers"),
                    provider: res.data,
                    preloader: false
                })
            }else{
                dispatch({
                    type: 'UPDATE_PROVIDER_SUCCESS',
                    providers:  tableUpdate(res, "providers"),
                    provider: clear,
                    preloader: false
                })
            }
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_update_failed});
        });
    }
}

const destroy = (id) => {
    return (dispatch) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(URL + store.getState().company.id + '/accounts/'+ id)
        .then( (res) => {
            var succesful = store.getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:store.getState().json_lang.custom_success.delete_successful});
            /*dispatch({
                type: 'PROVIDER_DELETED',
                providers: tableRemoveAcount(res, "providers"),
                provider: clear,
                preloader: false
            });*/
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: store.getState().json_lang.custom_errors.user_delete_failed });
        });
    }
}

const sendmail  = (email) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.post(`${URL+getState().company.id}/confirm/${email}?type=provider`).then( (res) => {
            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.email_sent});
            dispatch({
                type: 'UPDATE_PROVIDER_SUCCESS',
                providers: getState().providers,
                provider: getState().provider,
                preloader: false
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed});

        });
    }
}

const sendsms  = (payload) => {
    const { phone = null, account_id= null } = payload
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        axios.post(`${URL+getState().company.id}/accounts/${account_id}/send-phone-code`, { phone }).then( (res) => {
            var succesful = getState().json_lang.common.success
            Notification.show({type: "success", title:succesful, msg:getState().json_lang.custom_success.sms_sent});
            dispatch({
                type: 'UPDATE_PROVIDER_SUCCESS',
                providers: getState().providers,
                provider: getState().provider,
                preloader: false
            })
        }).catch((err) => {
            if(err.data.message && err.data.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.status_code}`, msg: err.data.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_delete_failed});

        });
    }
}

const searchQueryProvider = (query = "") => {
   return (dispatch) => {
        axios.get(URL + store.getState().company.id + '/providers' + (query ? "?search="+query : ''))
        .then( (res) => {
            dispatch({
                type: 'AUTOCOMPLETE_PROVIDER',
                providers: res.data.data
            })
        }).catch((err) => {
            if (err.message) {
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }
        });
    }
}

const statusAccount = (id,statusAccount) => {
    return (dispatch,getState) => {
        return axios.post(`${URL}${getState().company.id}/accounts/${id}/${statusAccount}`).then( (res) => {
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.saved_successful});

            /* let provider = getState().providers.find( (provider,key) => {
                return parseInt(provider.account_id,10) === parseInt(id,10)
            }) */
            //provider.account.status = res.data.status
            /* dispatch({
                type: 'UPDATE_PROVIDER_SUCCESS',
                providers:  tableUpdate(res, "providers"),
                provider: clear,
                preloader: false
            }) */
        }).catch((err) => {
            console.log("error ",err)
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title: err && err.title != "" ? err.title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const updateProviderGeolocation = (newData) => {
    return (dispatch, getState) => {
        let list = [];
        const { providers } = getState();
        list = providers.data || providers;

        const index = list.findIndex(provider => provider.id === newData.id);
        const provider = list[index];

        if (provider) {
            if (newData.hasOwnProperty('status')) {
                provider.status = newData.status;
            }
            if (newData.latitude_e6 && newData.longitude_e6) {
                provider.position = [
                    parseInt(newData.latitude_e6, 10) / 1000000,
                    parseInt(newData.longitude_e6, 10) / 1000000,
                ];
                provider.time = true;
                provider.from = list[index].position;
                provider.to = [...provider.position];
            }

            list[index] = provider;

            return new Promise((resolve) => {
                dispatch({
                    type: "UPDATE_PROVIDER_GEOLOCATION",
                    providers: list,
                });
                resolve(list); // Resolvemos la promesa una vez que se despacha la acción
            });
        }
    }
}

const getServiceSkillGroup = () => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/service-skill-groups?with_skills=1`).then( (res) => {
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: res.data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: 'Error al buscar habilidades requeridas de los productos' });
        });
    }
}

const getProviderSkillsGroups = (id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.get(`${URL}${getState().company.id}/providers/${id}/service-skills`).then( (res) => {
            let data = [...getState().service_skill_groups]
            let activeSkills = []

            data.forEach( (data) => {
                if( data.skills.length > 0 ){
                    var test={
                        name:data.name,
                        skills:[]
                    }
                    data.skills.forEach( (skill) => {
                        res.data.forEach(  (res) => {
                            if(res.id === skill.id){
                                test.skills.push({name:skill.name})
                            }
                        })
                    })
                    if(test.skills.length > 0){
                        activeSkills.push(test)
                    }
                }
            })
            dispatch({
                type: 'LIST_PROVIDER_SKILLS_GROUP',
                providerSkillsGroups: activeSkills
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: 'Error al buscar habilidades requeridas de los productos' });
        });
    }
}

const addServiceSkillGroup = () => {
    return (dispatch, getState) => {
        var newData = { name: getState().new_service_skill_groups }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL}${getState().company.id}/service-skill-groups`,newData).then( (res) => {

            let new_service_skill_groups = [];
            res.data.skills =[];
            new_service_skill_groups.push(res.data);

            let update_data = new_service_skill_groups.concat(getState().service_skill_groups)

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const addSkill = (id) => {
    return (dispatch, getState) => {
        let newData = getState().service_skill_groups.find( (service_skill,key) => { return service_skill.id === parseInt( id,10 ) })
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var skill = { name: newData.new_name }
        return axios.post(`${URL}${getState().company.id}/service-skill-groups/${id}/service-skills`,skill).then( (res) => {
            let update_data = getState().service_skill_groups.map( (service_skill,key) => {
                if(service_skill.id === parseInt( id,10 )){
                    service_skill.skills = service_skill.skills.concat(res.data)
                    service_skill.new_name =''
                }
                return service_skill
            })
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
        }).catch((err) => {
            if(err.data.message)
               Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}
const editSkill= (id,group_id) => {
    return (dispatch, getState) => {
        let newData = getState().service_skill_groups.find( (service_skill,key) => { return service_skill.id === parseInt( group_id,10 ) })
        dispatch({type: "WAIT_FOR_RESPONSE"})
        var skill = { name: newData.name }
        return axios.patch(`${URL}${getState().company.id}/service-skills/${id}`,skill).then( (res) => {
            let update_data = getState().service_skill_groups.map( (service_skill,key) => {
                if(service_skill.id === parseInt( id,10 )){
                    service_skill.skills = service_skill.skills.concat(res.data)
                    service_skill.new_name =''
                }
                return service_skill
            })
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
        }).catch((err) => {
            /*if(err.data.message)
               Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            else*/
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}
const removeSkill = (id,group_id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${getState().company.id}/service-skills/${id}`).then( (res) => {
            let update_data = [...getState().service_skill_groups]
            update_data.map( (service_skill,key) => {
                if(parseInt(service_skill.id,10 ) === parseInt( group_id,10 )){
                    service_skill.skills = service_skill.skills.filter( (skill,key) => {
                        return parseInt(skill.id,10) !== parseInt(id,10)
                    })
                }
                return service_skill
            })

            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.update_successful});

        }).catch((err) => {
            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }else if (err.data.message){
                Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            }else{
                Notification.show({type: "error", title: 'Error', msg: '' });
            }
        });
    }
}
const editServiceSkillGroup = (id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let data = getState().service_skill_groups.find( (service_skill,key) => { return service_skill.id === parseInt( id,10 ) })
        return axios.patch(`${URL}${getState().company.id}/service-skill-groups/${id}`,data).then( (res) => {
            let update_data=getState().service_skill_groups.map( (service_skill,key) => {
                if(service_skill.id === parseInt(res.data.id,10)){ service_skill.reason = res.data.reason }
                return service_skill;
            })
            Notification.show({type: "success", title:getState().json_lang.common.success, msg:getState().json_lang.custom_success.delete_successful});
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: getState().json_lang.custom_errors.user_restore_failed });
        });
    }
}

const deleteServiceSkillGroup = (id) => {
    return (dispatch, getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.delete(`${URL}${getState().company.id}/service-skill-groups/${id}`).then( (res) => {
            let update_data=getState().service_skill_groups.filter( (service_skill,key) => {
                return (service_skill.id !== parseInt(res.data.id,10))
            })

            Notification.show({type: "success", title:getState().json_lang.common.success, msg:store.getState().json_lang.custom_success.delete_successful});
            update_data.sort()
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            });
        }).catch((err) => {
            if(err.message && err.message !== 'generic'){
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            }else if (err.data.message){
                Notification.show({type: "error", title: 'Error', msg: getState().json_lang.custom_errors[err.data.message] });
            }else{
                Notification.show({type: "error", title: 'Error', msg: '' });
            }
        });
    }
}

const toggleServiceSkillGroup = (value) => {
    return (dispatch,getState) => {
        let name = value.name.split('-')
        if(name.length > 1){
            var update_data=getState().service_skill_groups.map( (service_skill,key) => {
                if(key===parseInt(name[1],10) ){
                    if(name[0] === 'name' || name[0] === 'new_name' ){
                        service_skill[name[0]] = value.data;
                    }else{
                        service_skill.skills[name[2]].name = value.data
                    }
                }
                return service_skill;
            })
            dispatch({
                type: 'LIST_SERVICE_SKILL_GROUPS',
                service_skill_groups: update_data
            });
        }else{
            var data = getState().new_service_skill_groups = value.data;
            dispatch({
                type: 'NEW_SERVICE_SKILL_GROUPS',
                new_service_skill_groups: data
            })
        }
    }
}

const fetchProvidersVehicle = (id) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let { company } = getState();
        return axios.get(`${URL+company.id}/providers/${id}/delivery-vehicles?limit=0`).then( (res) => {
            dispatch({
                type: 'FETCH_PROVIDERS_VEHICLES',
                providersVehicle: res.data
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg:"" });
            }
        });
    }
}
const attachVehicleProvider = (providerId,vehicleID) => {
    return (dispatch,getState) => {
       // dispatch({type: "WAIT_FOR_RESPONSE"})
        let { company, json_lang,providersVehicle,vehicles } = getState();

        let find = vehicles.find((vehicle,key) => {return vehicle.id === parseInt(vehicleID,10) });
        return axios.put(`${URL+company.id}/providers/${providerId}/delivery-vehicles/${vehicleID}`).then( (res) => {
            let update =providersVehicle.concat(find)
            Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful});

            dispatch({
                type: 'FETCH_PROVIDERS_VEHICLES',
                providersVehicle: update
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}
const dettachVehicleProvider = (providerId,vehicleId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let { company, json_lang,providersVehicle } = getState();
        return axios.delete(`${URL+company.id}/providers/${providerId}/delivery-vehicles/${vehicleId}`).then( (res) => {
            Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            let update =providersVehicle.filter( (item) => { return ( item.id !== vehicleId ) })
            dispatch({
                type: 'FETCH_PROVIDERS_VEHICLES',
                providersVehicle: update
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}

const getVehicle = (vehicleId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let { company } = getState();
        return axios.get(`${URL+company.id}/delivery-vehicles/${vehicleId}`).then( (res) => {
            dispatch({
                type: 'STORE_VEHICLE',
                vehicle: res.data
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}

const toggleDataVehicle = (value) => {
    return (dispatch,getState) => {
        var data = { ...getState().vehicle }
        data[value.name] = value.data;
        dispatch({
            type: 'STORE_VEHICLE',
            vehicle: data
        })
    }
}

const clearvehicle = () => {
    return (dispatch,getState) => {
        let update ={
            name:""
        }
        dispatch({
            type: 'STORE_VEHICLE',
            vehicle: update
        })
    }
}

const updateVehicle = (vehicleId) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"})
        let { company, json_lang,vehicles,vehicle } = getState();
        return axios.patch(`${URL+company.id}/delivery-vehicles/${vehicleId}`,vehicle).then( (res) => {
            let update =vehicles.map( (item) => {
                if( item.id === vehicleId ){
                    item=res.data
                }
                return item
            })
            Notification.show({
                type: "success",
                title:json_lang.common.success,
                msg: json_lang.custom_success.saved_successful
            });
            dispatch({
                type: 'FETCH_VEHICLES',
                vehicles: update
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}

const toggleAccess = (access_id, branch) => {
    return (dispatch,getState) => {
        let { provider,/*session,*/company,json_lang, providerBranchAccesses } = getState();
        let data = { ...provider };

        let accss ={
            access_type: provider.access_type,
            access_id: access_id
        }

        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+company.id}/providers/${data.id}/grant-access`,accss).then( (res) => {
            res.data.access_type = res.data.access_type.split('\\')[1].toLowerCase()
            /*let branchS = [...session.accesses].find(e => e.access_id === parseInt(access_id,10));
            console.log("branchS",session.accesses,)*/
            //if(branchS && branchS.related_access){
                data.accesses.push(res.data);
                Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful});
            //}
            dispatch({
                type: 'FETCH_PROVIDER',
                provider: data
            });
            if(branch){
                const newBranches = [...providerBranchAccesses];
                newBranches.push(branch.related_access);
                dispatch({
                    type: 'FETCH_PROVIDER_BRANCHES_ACCESSES',
                    providerBranchAccesses: newBranches
                });
            }
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}

const removeAccess = (access,type) => {
    return (dispatch,getState) => {
        let { provider ,company,json_lang} = getState();
        let data = { ...provider }
        let accss ={
            access_type: type ? type : 'company',
            access_id: access.access_id ? access.access_id : access
        }
        dispatch({type: "WAIT_FOR_RESPONSE"})
        return axios.post(`${URL+company.id}/providers/${data.id}/revoke-access`,accss).then( (res) => {
            Notification.show({type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful});

            let reveItem = access && access.access_id ? parseInt(access.access_id,10) : access;
            let branchS = data.accesses.filter(e => e.access_id !== reveItem);
            data.accesses = branchS

            dispatch({
                type: 'FETCH_PROVIDER',
                provider: data
            })
        }).catch((err) => {
            if(err && err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.data.message});
            else{
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "" });
            }
        });
    }
}

const updateProviderPayment = (data, id, fromInvoice) => {
    return (dispatch,getState) => {
		let { company, json_lang, invoice } = getState();

        const paymentData = {
            settings: {
                payout_accounts: [ ...data]
            }
        }

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL + company.id}/providers/${id}`, paymentData).then( (res) => {
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            if(fromInvoice){
                dispatch({
                    type: 'FETCH_INVOICE',
                    invoice:{
                        ...invoice,
                        payout_accounts: paymentData.settings.payout_accounts
                    }
                });
            } else {
                dispatch({
                    type: 'FETCH_PROVIDER',
                    provider: res.data
                })
            }
		})
		.catch((err) => {
			if(err.message && err.message !== 'generic')
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
			else
				Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: "Error al guardar el método de pago" });
		});
	}
}

const updateProviderAdvanceSettings = (body, id) => {
    return (dispatch,getState) => {
		let { company, json_lang } = getState();

        const posData = {
            settings: {
                ...body
            }
        }

		dispatch({type: "WAIT_FOR_RESPONSE"})
		return axios.patch(`${URL + company.id}/providers/${id}`, posData).then( (res) => {
			Notification.show({ type: "success", title:json_lang.common.success, msg:json_lang.custom_success.saved_successful });
            dispatch({
                type: "INVALID_ADVANCE_CONFIG",
                invalidConfig: {}
            });
		})
		.catch((err) => {
            dispatch({type: "REMOVE_LOADING"})  
            if(err.data && err.data.error_code){
                const error = err.data;
                switch(error.error_code){
                    case 'ER422':
                        if(error.errors){
                            const errors = Object.keys(error.errors).reduce((acc, key) => {
                                const splitedKey = key.split(".");
                                acc[splitedKey[1]] = json_lang.custom_errors[splitedKey[1] + "_format"];
                                return acc;
                            }, {});
                            console.log("errorssssss",errors)

                            dispatch({
                                type: "INVALID_ADVANCE_CONFIG",
                                invalidConfig: {
                                    ...errors
                                },
                            });
                        } else {
                            if(error.description){
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                            } else {
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Ocurrió un error inesperado al guardar el método de pago" });
                            }
                        }
                        break;
                    case 'ER409':
                        if(error.errors){
                            const errors = Object.keys(error.errors).reduce((acc, key) => {
                                const splitedKey = key.split(".");
                                acc[splitedKey[1]] = json_lang.custom_errors[splitedKey[1] + "_conflict"];
                                return acc;
                            }, {});
                            dispatch({
                                type: "INVALID_ADVANCE_CONFIG",
                                invalidConfig: {
                                    ...errors
                                },
                            });
                        } else {
                            if(error.description){
                                if(error.description.includes("pos_serial")){
                                    dispatch({
                                        type: "INVALID_ADVANCE_CONFIG",
                                        invalidConfig: {
                                            pos_serial: json_lang.custom_errors.pos_serial_conflict
                                        }
                                    });
                                } else {
                                    Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                                }
                            } else {
                                Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Ocurrió un error inesperado al guardar el método de pago" });
                            }
                        }
                        break;
                    default:
                        if(error.description){
                            Notification.show({type: "error", title:`Error ${error.error_code}`, msg: error.description });
                        } else {
                            Notification.show({type: "error", title:`Error ${error.error_code}`, msg: "Error al guardar el método de pago" });
                        }
                        break;
                }
            } else {
                Notification.show({type: "error", title:`Error`, msg: "Error al guardar el método de pago" });
            }
		});
	}
}

const fetchProviderStatistics = (id, mode = "today", date) => {
    return (dispatch,getState) => {
        dispatch({type: "WAIT_FOR_RESPONSE"});
        let url = "";
        if(mode === "range"){
            url += `&day_from=${date.dayFrom}&day_to=${date.dayTo}`;
        }
        if(mode === "day"){
            url += `&day=${date}`;
        }

        return axios.get(`${URL + getState().company.id}/providers/${id}/statistics?mode=${mode}` + url).then( (res) => {
            dispatch({
                type: 'FETCH_PROVIDER_STATISTICS',
                providerStatistics: res.data
            });
        }).catch((err) => {
            dispatch({type: "REMOVE_LOADING"});
            if(err.message && err.message !== 'generic')
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err.message});
            else
                Notification.show({type: "error", title:`Error ${err && err.data && err.data.error_code}`, msg: err && err.data && err.data.description });
        });
    }
}

export {
    removeAccess,
    toggleAccess,
    clearvehicle,
    updateVehicle,
    toggleDataVehicle,
    getVehicle,
    dettachVehicleProvider,
    attachVehicleProvider,
    fetchProvidersVehicle,
    clearProviders,
    clearProvider,
    clearProviderAdvanceConfig,
    updateProviderGeolocation,
    updateAvatar,
    toggleData,
    update,
    register,
    find,
    fetchProviders,
    statusAccount,
    destroy,
    sendmail,
    sendsms,
    searchQueryProvider,
    fetchArchivedProviders,
    getServiceSkillGroup,
    toggleServiceSkillGroup,
    addServiceSkillGroup,
    deleteServiceSkillGroup,
    editServiceSkillGroup,
    addSkill,
    removeSkill,
    editSkill,
    getProviderSkillsGroups,
    updateProviderPayment,
    updateProviderAdvanceSettings,
    fetchProviderStatistics
};



// WEBPACK FOOTER //
// ./src/store/actions/providerActions.js